var React = require('react');

function Moon (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"moon","d":"M42.357,52a10.431,10.431,0,0,1-4.214-19.94.714.714,0,0,1,.94.94,9.274,9.274,0,0,0-.655,3.643,8.939,8.939,0,0,0,8.929,8.929A9.274,9.274,0,0,0,51,44.914a.714.714,0,0,1,.94.94A10.383,10.383,0,0,1,42.357,52Z","transform":"translate(-32 -31.997)"}));
}

Moon.defaultProps = {"id":"sun_moon","viewBox":"0 0 20 20"};

module.exports = Moon;

Moon.default = Moon;
